export default __webpack_public_path__ + "static/media/Interactivevideos.07c4308c.svg";